/* global axios */
import ApiClient from '../ApiClient';

const requestConfig = (extraHeaders = {}) => {
  const csrfToken =
    document.querySelector('meta[name="csrf-token"]')?.content || '';

  return {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
      ...extraHeaders,
    },
  };
};

class WhatsappChannel extends ApiClient {
  constructor() {
    super('whatsapp', { accountScoped: true });
  }

  fetchProfile(options = {}) {
    return axios.get(
      `${this.apiVersion}/profile`,
      requestConfig(options.headers || {})
    );
  }

  createEmbeddedSignup(params, options = {}) {
    return axios.post(
      `${this.baseUrl()}/whatsapp/authorization`,
      params,
      requestConfig(options.headers || {})
    );
  }

  fetchEmbeddedSignupToken(options = {}) {
    return axios.get(
      `${this.baseUrl()}/whatsapp/embedded_signup_token`,
      requestConfig(options.headers || {})
    );
  }

  reauthorizeWhatsApp({ inboxId, ...params }) {
    return axios.post(
      `${this.baseUrl()}/whatsapp/authorization`,
      {
        ...params,
        inbox_id: inboxId,
      },
      requestConfig()
    );
  }
}

export default new WhatsappChannel();
